import {Profile} from "../profile";
import React, {ComponentProps, useContext, useState} from "react";

interface ProfileContext {
  profile: Profile | undefined;
  setProfile: (profile: Profile) => void;
}

export const ProfileContext = React.createContext<ProfileContext>(
  {} as ProfileContext,
);
export const useProfileContext = () => useContext(ProfileContext);
export const ProfileContextProvider = ({
  children,
}: ComponentProps<"div">): JSX.Element => {
  const [profile, setProfile] = useState<Profile | undefined>(undefined);

  return (
    <ProfileContext.Provider
      value={{
        profile,
        setProfile,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};
